import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { config } from "../config";
import { parse, stringify } from "qs";

export const prepareSearchParams = (
  searchTerm,
  pageNum,
  searchFields,
  date_from,
  date_to,
  sources,
  collapse
) => {
  const params = {
    query: searchTerm,
    page: pageNum,
    fields: searchFields,
    date_from: date_from,
    date_to: date_to,
    collapse: collapse,
  };
  params.filter_fields = [];
  if (sources && sources.length) {
    params.filter_fields.push(`source___${sources.join("___")}`);
  }
  return params;
};

export const callBackend = (url, params, responseType) => {
  const ax_conf = {
    params: params,
    withCredentials: true,
    paramsSerializer: {
      encode: parse,
      serialize: (p) => stringify(p, { arrayFormat: "repeat" }),
    },
  };
  if (responseType) {
    ax_conf.responseType = responseType;
  }
  return axios.get(url, ax_conf);
};

const requestBackendForSearch = async ({
  searchTerm,
  pageNum,
  searchFields,
  sources,
  date_from,
  date_to,
  collapse,
}) => {
  try {
    const params = prepareSearchParams(
      searchTerm,
      pageNum,
      searchFields,
      date_from,
      date_to,
      sources,
      collapse
    );
    const resp = await callBackend(`${config.API_URL}/search`, params);
    return resp.data;
  } catch (e) {
    console.error(e);
  }
  return {
    next_page: null,
    num_docs: 0,
    data: [],
    message: "Error while fetching the search results",
  };
};

export const search = createAsyncThunk(
  "aando/search",
  async (_, { getState }) => {
    try {
      const state = getState();
      const {
        searchTerm,
        searchFields,
        sources,
        date_from,
        date_to,
        collapseResults,
      } = state.searchSlice;
      return await requestBackendForSearch({
        searchTerm,
        searchFields,
        pageNum: 1,
        sources,
        date_from,
        date_to,
        collapse: collapseResults,
      });
    } catch (e) {
      console.error(e);
    }
  }
);

export const fetchNext = createAsyncThunk(
  "aando/fetchNext",
  async (_, { getState }) => {
    try {
      const state = getState();
      const {
        searchTerm,
        searchFields,
        sources,
        date_from,
        date_to,
        collapseResults,
      } = state.searchSlice;
      const page_num = state.searchSlice.searchResults.next_page;
      return await requestBackendForSearch({
        searchTerm,
        pageNum: page_num,
        searchFields,
        sources,
        date_from,
        date_to,
        collapse: collapseResults,
      });
    } catch (e) {
      console.error(e);
    }
  }
);

export const downloadCSV = (res) => {
  const href = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", "articles.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
